import { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { ChevronRight16Regular, Pin16Regular } from '@/components/Icon'
import ThreadListRow from './ThreadListRow'
import { useThreadStatusStore } from '@/store/threadStatusStore'
import styles from './HomeNavPane.module.scss'

/** Threads as bare titles — the chat glyph is dropped, the title carries the row. */

export default function HomeNavThreadRows({
  threads, emptyNote, maxVisible, onShowMore, selectedThreadId,
  onSelectThread, onThreadMenuAction, onRenameThread, menuSurface = 'threads',
}) {
  useEffect(() => {
    if (selectedThreadId) useThreadStatusStore.getState().markRead(selectedThreadId)
  }, [selectedThreadId])

  if (!threads.length) {
    return <Typography component="p" className={styles.emptyNote}>{emptyNote}</Typography>
  }

  const hasOverflow = Number.isFinite(maxVisible) && threads.length > maxVisible
  const visible = hasOverflow ? threads.slice(0, maxVisible) : threads
  const renderRow = (thread) => (
    <Box component="li" key={thread.id} className={styles.threadListItem}>
      <ThreadListRow plain title={thread.title} thread={thread} menuSurface={menuSurface}
        active={thread.id === selectedThreadId}
        onClick={() => { useThreadStatusStore.getState().markRead(thread.id); onSelectThread?.(thread) }}
        onThreadMenuAction={onThreadMenuAction} onRenameThread={onRenameThread}
        showChatIcon={false}
        LeadingIcon={menuSurface === 'pinned' ? Pin16Regular : undefined} />
    </Box>
  )

  return (
    <Box component="ul" className={styles.threadList} aria-label="Threads">
      {visible.map(renderRow)}
      {hasOverflow ? (
        <Box component="li" className={styles.threadListMore}>
          <button type="button" className={styles.threadListMoreButton} onClick={onShowMore}>
            View {threads.length - maxVisible} more<ChevronRight16Regular aria-hidden />
          </button>
        </Box>
      ) : null}
    </Box>
  )
}
